export const colors = {
  surface: "#FFFFFF",
  onSurface: "#0F2540",
  surfaceSecondary: "#F4F7FA",
  onSurfaceSecondary: "#0F2540",
  surfaceTertiary: "#E6EDF5",
  onSurfaceTertiary: "#0F2540",
  surfaceInverse: "#0F2540",
  onSurfaceInverse: "#FFFFFF",
  muted: "#64748B",
  brand: "#2F6BFF",
  onBrand: "#FFFFFF",
  brandPrimary: "#2F6BFF",
  onBrandPrimary: "#FFFFFF",
  brandSecondary: "#E0E8FF",
  onBrandSecondary: "#2F6BFF",
  brandTertiary: "#F0F4FF",
  onBrandTertiary: "#2F6BFF",
  success: "#059669",
  onSuccess: "#FFFFFF",
  successSurface: "#E7F6EF",
  onSuccessSurface: "#047857",
  warning: "#E67E22",
  onWarning: "#FFFFFF",
  warningSurface: "#FDF0E4",
  onWarningSurface: "#C2610C",
  error: "#EF4444",
  onError: "#FFFFFF",
  errorSurface: "#FDECEC",
  onErrorSurface: "#DC2626",
  info: "#3B82F6",
  onInfo: "#FFFFFF",
  border: "#E2E8F0",
  borderStrong: "#CBD5E1",
  divider: "#F1F5F9",
  ringTrack: "#E6EDF5",
};

// fontWeight tokens (font-family is set globally to Plus Jakarta Sans)
export const fonts = { regular: 400, medium: 500, semibold: 600, bold: 700 };

export const moduleColors = [
  { accent: "#2F6BFF", tint: "#E9F0FF" },
  { accent: "#059669", tint: "#E5F6EF" },
  { accent: "#E67E22", tint: "#FCEFE1" },
  { accent: "#7C3AED", tint: "#F0E9FE" },
  { accent: "#0EA5E9", tint: "#E3F4FD" },
  { accent: "#E11D48", tint: "#FDE7EC" },
  { accent: "#0D9488", tint: "#E1F4F2" },
  { accent: "#4F46E5", tint: "#E8E9FE" },
];
